// crepas-viewer(dragdocs) 리소스 지연 로더.
//
// crepas.wasm(~33MB) preload 가 SPA 초기 렌더링(메인 번들 → 라우트 청크 →
// locales/API 호출)과 대역폭을 경쟁하지 않도록, index.html 의 window.load
// 시점이 아닌 "앱 첫 렌더링 이후" 시점에 앱 코드가 직접 주입한다.
// (window.load 는 메인 번들 다운로드 완료 시점일 뿐, SPA 첫 화면 렌더링보다
// 훨씬 이르다 — docs/wiki/domain/rules/dragdocs-integration.md 참고)
//
// 주의: extensionBridge.js 와 동일하게 이 파일은 의존성 zero 로 유지할 것
// (redux / api / i18n import 금지).

// dragdocs 라이선스 clientId. 비밀이 아니라(스크립트 URL 쿼리로 노출) 환경변수로만
// 분리한다 — vendorUuid(라이선스 발급용 마스터 키)는 프론트에 두면 안 됨.
// REACT_APP_CREPAS_CLIENT_ID 미설정 시 현재 운영 키로 폴백(동작 변화 없음).
const CREPAS_CLIENT_ID = process.env.REACT_APP_CREPAS_CLIENT_ID || '8XAK-XDT7-UGF4-C9NG-TGCE'
const PREFETCH_IDLE_TIMEOUT_MS = 10000
const PREFETCH_FALLBACK_DELAY_MS = 3000

let loadPromise = null

export function getCrepasBaseURL() {
  const h = window.location.hostname
  const isDev = h === 'localhost' || h === '127.0.0.1'
  // dev/prod 분기는 라이브러리 내부 fetch URL 과 일치해야 캐시 적중 (위키 룰 2)
  return `https://cdn.dragdocs.com/crepas-viewer@2.0.4/${isDev ? 'd' : 'dist'}`
}

export function loadCrepasViewer() {
  if (window.CrepasViewer != null) {
    return Promise.resolve()
  }
  if (loadPromise != null) {
    return loadPromise
  }

  loadPromise = new Promise((resolve, reject) => {
    const baseUrl = getCrepasBaseURL()

    // wasm preload — fetchPriority='low' 로 다른 요청에 대역폭 양보.
    // as / crossorigin / type 은 라이브러리 내부 fetch 옵션과 일치해야
    // 캐시 적중 (불일치 시 두 번 다운로드 — 위키 룰 2)
    const wasmLink = document.createElement('link')
    wasmLink.rel = 'preload'
    wasmLink.as = 'fetch'
    wasmLink.type = 'application/wasm'
    wasmLink.crossOrigin = 'anonymous'
    wasmLink.fetchPriority = 'low'
    wasmLink.href = `${baseUrl}/office/crepas.wasm`
    document.head.appendChild(wasmLink)

    const script = document.createElement('script')
    script.crossOrigin = 'anonymous'
    script.fetchPriority = 'low'
    script.src = `${baseUrl}/crepas-viewer.min.js?clientId=${CREPAS_CLIENT_ID}`
    script.onload = () => resolve()
    script.onerror = () => {
      // 실패 시 다음 호출에서 재시도할 수 있도록 리셋
      loadPromise = null
      reject(new Error('crepas-viewer load failed'))
    }
    document.head.appendChild(script)
  })

  return loadPromise
}

// 앱 첫 렌더링 이후 idle 타임에 미리 받아두기 — 첫 미리보기 체감 속도용.
// 실패는 무시한다 (docViewer 가 마운트 시 on-demand 로 재시도).
export function prefetchCrepasViewerOnIdle() {
  const start = () => {
    loadCrepasViewer().catch(() => {})
  }
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(start, { timeout: PREFETCH_IDLE_TIMEOUT_MS })
  } else {
    setTimeout(start, PREFETCH_FALLBACK_DELAY_MS)
  }
}
